import type { FetchTranscript } from './scenes/documents/use-following-transcript';

import { createContext } from 'react';

export interface MediaStage {
  /** True only on the surface that just opened a source for the user. */
  playOnOpen: boolean;
  /** When it turns true, a playing recording pauses. It does not resume. */
  holdMedia: boolean;
  /** Told where the user stopped or moved a recording, so Ari can continue from there. */
  onMediaPosition?: (position: MediaPosition) => void;
  /** Reads the lines of a recording at another moment, so its card follows the playback. */
  fetchTranscript?: FetchTranscript;
  /** Called while a video or a recording plays, so Ari keeps the session open. */
  onMediaKeepAlive?: () => void;
}

/** Ari ends a session after 120 s with no activity. A video streams outside the session, so it beats this often. */
export const MEDIA_KEEPALIVE_EVERY_MS = 30_000;

/** Where the player of a recording source stands. */
export interface MediaPosition {
  /** The source's short id, as Ari knows it. */
  sourceId: string;
  positionMs: number;
  /** How long the recording is, once the player knows it. */
  durationMs?: number;
}

export const MediaStageContext = createContext<MediaStage>({ playOnOpen: false, holdMedia: false });
